import React, { useState, useEffect } from 'react'
import injectSheet from 'react-jss'
import { PersonalizationStatus } from 'aria-viewer/tour/constants/PersonalizationStatus'
import SparkleAnimation from './SparkleAnimation'

const styleSheet = {
    banner: {
        position: 'fixed',
        height: '29px',
        width: '202px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#07131E',
        borderRadius: '4px',
        zIndex: 10000,
        top: ({ isDeviceMobile }) => (isDeviceMobile ? '' : '20px'),
        bottom: ({ isDeviceMobile }) => (isDeviceMobile ? '15%' : ''),
        left: '50%',
        transform: 'translateX(-50%)',
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
    },
    message: {
        color: 'white',
        lineHeight: '21px',
        fontSize: '14px',
        fontWeight: 500,
    },
    sparkle: {
        height: '17.5px',
        width: '17.75px',
    },
}

const PersonalizingBanner = ({ status, classes, isDeviceMobile }) => {
    const [showBanner, setShowBanner] = useState(false)

    useEffect(() => {
        if (status === PersonalizationStatus.ERROR) {
            setShowBanner(true)
            const timer = setTimeout(() => {
                setShowBanner(false)
            }, 4000)

            return () => clearTimeout(timer)
        }
    }, [status])

    return (
        <>
            {status === PersonalizationStatus.IN_PROGRESS && (
                <div className={classes.banner}>
                    <div className={classes.container}>
                        <SparkleAnimation />
                        <p className={classes.message}>Personalizing...</p>
                    </div>
                </div>
            )}
            {status === PersonalizationStatus.ERROR && showBanner && (
                <div className={classes.banner} style={{ width: '252px' }}>
                    <p className={classes.message}>Sorry, couldn't load personalization</p>
                </div>
            )}
        </>
    )
}

export default injectSheet(styleSheet)(PersonalizingBanner)
